import { supportsPassiveEventListeners } from '@angular/cdk/platform';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { PaymentSettingsService } from 'app/core/http/services/payment-settings.service';
import { PractitionerOrganizationAffiliationService } from 'app/core/http/services/practititoner-organization-affiliation.service';
import { PaymentSettings } from 'app/core/interfaces/payment-settings';
import { BaseComponent } from 'app/modules/shared/components/base.component';

// Interfaces simplificadas
interface Agreement {
  name: string;
  accepted: boolean;
}

interface HealthPlan {
  name: string;
  accepted: boolean;
  agreements: Agreement[];
}

@Component({
  selector: 'health-plan',
  templateUrl: './health-plan.component.html',
  styleUrls: ['./health-plan.component.css']
})
export class HealthPlanComponent extends BaseComponent implements OnInit {

  public title = 'Planos de Saúde';
  public form!: FormGroup;
  public healthPlans: HealthPlan[] = [];
  public healthPlansOrganization: HealthPlan[]  = []
  public mode = 'CREATE';
  public organizationSettings!: PaymentSettings;

  public affiliation: any = {}

  // Status da submissão
  public submittedSettings = false;
  public successSettings = false;

  @Input() organizationId: string = '';
  @Input() affiliationId: string = '';

  // Estrutura de planos e convênios
  // healthPlansOrganization = [
  //   { name: "Unimed", agreements: [{ name: "Regional 40%" }, { name: "Regional 60%" }, { name: "Empresarial" }] },
  //   { name: "Bradesco Saúde", agreements: [{ name: "Regional 40%" }, { name: "Regional 60%" }, { name: "Empresarial" }, { name: "Familiar" }] }
  // ];

  constructor(
    private fb: FormBuilder,
    private organizationSettingsService: PaymentSettingsService,
    private affiliationPractitionerOrganizationService: PractitionerOrganizationAffiliationService,
    private injector: Injector
  ) {
    super(injector);
  }

   ngOnInit() {
      this.getOrganizationSettings()
      this.getPractitionerHealthPlans()
      this.form = this.fb.group({ healthPlans: this.fb.array(this.createHealthPlans()) });

 
   }

  createHealthPlans(): FormGroup[] {
    return this.healthPlansOrganization.map(planOrg => {
      const matchingPlan = this.healthPlans.find(plan => plan.name === planOrg.name) || { accepted: false, agreements: [] };
      return this.fb.group({
        name: [planOrg.name],
        accepted: [matchingPlan.accepted],
        agreements: this.fb.array(planOrg.agreements.map(agreementOrg => {
          const matchingAgreement = matchingPlan.agreements.find(a => a.name === agreementOrg.name) || { accepted: false };
          return this.fb.group({
            name: [agreementOrg.name],
            accepted: [matchingAgreement.accepted]
          });
        }))
      });
    });
  }

  getHealthPlansFormArray(): FormArray {
    return this.form.get('healthPlans') as FormArray;
  }

  getOrganizationSettings(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.organizationSettingsService.findByOrganization(this.organizationId)
        .subscribe({
          next: (settings: PaymentSettings) => {
            this.organizationSettings = settings;
            
            this.healthPlansOrganization = settings.healthcare_plans!!


            this.mode = settings ? 'UPDATE' : 'CREATE';
  
            this.form.setControl('healthPlans', this.fb.array(this.createHealthPlans()));
  
            resolve();
          },
          error: (err) => reject(err)
        });
    });
  }

  getPractitionerHealthPlans() : Promise<void>{
    
    return new Promise((resolve, reject) => {
      this.affiliationPractitionerOrganizationService.showByAffiliationId(this.affiliationId)
      .subscribe({
        next: (affiliationPractitioner: any) => {
          this.affiliation = affiliationPractitioner
          this.healthPlans = affiliationPractitioner.healthcare_plans

          this.form.setControl('healthPlans', this.fb.array(this.createHealthPlans()));
  
          resolve();
        },
        error: (err) => {
          console.log('erro', err);
        },
      })
    });

  }
  
  updateHealthPlans() {
    this.affiliation.healthcare_plans = this.form.value.healthPlans;

    this.affiliationPractitionerOrganizationService.update(this.affiliationId, this.affiliation)
      .subscribe({
        next: (updatedHealthPlans) => {
          this.affiliation = updatedHealthPlans;
          this.submittedSettings = true;
          this.successSettings = true;
        },
        error: (err) => this.handleError(err)
      });
  }

  handleSuccess(settings: PaymentSettings) {
    this.organizationSettings = settings;
    this.submittedSettings = true;
    this.successSettings = true;
    console.log("Operação bem-sucedida", settings);
  }

  handleError(error: any) {
    console.error("Erro na operação", error);
    this.submittedSettings = true;
    this.successSettings = false;
  }

  getAgreementsFormArray(planIndex: number): FormArray {
    return this.getHealthPlansFormArray().at(planIndex).get('agreements') as FormArray;
  }
  
  submit() {
    console.log(this.form.value);
  }

}
